import RegistrationService from "../../services/RegistrationService";
import { TaxValidationRequest, TaxValidationResponse, ValidationResponseCode, ValidationStatus } from "./types";
import { getTranslations } from "../../translations";

export class TaxNumberHelper {
  static getTaxNumberErrorMessage(
    status: ValidationStatus,
    responseCode: ValidationResponseCode,
    countryCode: string,
    locale: string = "en-GB"
  ): string {
    const errorMessages = getTranslations(locale).taxNumberValidationResponseMessages;
    const { taxTypes: { vat: vat, tax: taxTitle } } = getTranslations(locale).taxNumberValidationResponseMessages;

    if (status === "Valid") {
      return "";
    }
    let message = errorMessages[responseCode];
    if (!message) {
      if (countryCode?.toLowerCase() === "mex") {
        message = errorMessages.mexico[responseCode] || errorMessages.mexico[ValidationResponseCode.UnknownValidationError];
        return message;
      } else if (countryCode?.toLowerCase() === 'aus') {
        return errorMessages.abn[responseCode] || errorMessages.abn[ValidationResponseCode.AbnUnknownValidationError];
      } else if (countryCode?.toLowerCase() === 'gbr') {
        message = errorMessages.default[responseCode] || errorMessages.default[ValidationResponseCode.UnknownValidationError];
        return message.replace('{TAX_TYPE}', vat)
      } else {
        message = errorMessages.default[responseCode] || errorMessages.default[ValidationResponseCode.UnknownValidationError];
        return message.replace('{TAX_TYPE}', taxTitle)
      }
    }
    return message;
  }

  static async validateTaxNumber(url: string, body: TaxValidationRequest, locale: string = "en-GB"): Promise<TaxValidationResponse> {
    const response = await RegistrationService.validateTaxIdentifier(
      url,
      body
    );
    const status = response?.body?.validationStatus;
    const responseCode: ValidationResponseCode = response?.body?.validationResponseCode;
    return {
      ...response.body,
      message: this.getTaxNumberErrorMessage(status, responseCode, body.countryCode, locale)
    };
  }
}
